import {MultiCurrencyPriceFragment} from '../../../../gql/graphql';
import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {BreakdownModel} from './Breakdown.model';

export class PricingModel {
  public unitPrice: PriceModel;
  public totalPrice: PriceModel;
  public priceUndetermined: boolean;
  public breakdown: BreakdownModel;

  constructor(params: PricingModel) {
    this.unitPrice = params.unitPrice;
    this.totalPrice = params.totalPrice;
    this.priceUndetermined = params.priceUndetermined;
    this.breakdown = params.breakdown;
  }

  public static fromCheckoutV1({
    unitPrice,
    totalPrice,
    priceUndetermined,
    fullPrice,
    salePrice,
    totalModifiersPrice,
    confirmedQuantity,
    hidePrice,
    modelContext,
  }: {
    unitPrice?: MultiCurrencyPriceFragment | null;
    totalPrice?: MultiCurrencyPriceFragment | null;
    priceUndetermined?: boolean | null;
    fullPrice?: MultiCurrencyPriceFragment | null;
    salePrice?: MultiCurrencyPriceFragment | null;
    totalModifiersPrice?: MultiCurrencyPriceFragment | null;
    confirmedQuantity: number;
    hidePrice?: boolean | null;
    modelContext: ModelContext;
  }) {
    const modeledTotalPrice = PriceModel.fromCheckoutV1(totalPrice, modelContext);

    return new PricingModel({
      unitPrice: PriceModel.fromCheckoutV1(unitPrice, modelContext),
      totalPrice: modeledTotalPrice,
      priceUndetermined: (hidePrice || priceUndetermined) ?? false,
      breakdown: BreakdownModel.fromCheckoutV1({
        unitPrice,
        fullPrice,
        salePrice,
        totalModifiersPrice,
        confirmedQuantity,
        modeledTotalPrice,
        modelContext,
      }),
    });
  }
}
